var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobTypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_8838)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_654_8838",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_654_8838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.9492C9.38 18.9492 7.25 16.8192 7.25 14.1992C7.25 11.5792 9.38 9.44922 12 9.44922C14.62 9.44922 16.75 11.5792 16.75 14.1992C16.75 16.8192 14.62 18.9492 12 18.9492ZM12 10.9492C10.21 10.9492 8.75 12.4092 8.75 14.1992C8.75 15.9892 10.21 17.4492 12 17.4492C13.79 17.4492 15.25 15.9892 15.25 14.1992C15.25 12.4092 13.79 10.9492 12 10.9492Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 15.9509C10.7499 15.9509 10.4999 15.8209 10.3599 15.5909C10.1499 15.2309 10.2599 14.7709 10.6199 14.5609L11.3799 14.1009C11.4599 14.0609 11.4999 13.9709 11.4999 13.8909V12.9609C11.4999 12.5509 11.8399 12.2109 12.2499 12.2109C12.6599 12.2109 12.9999 12.5409 12.9999 12.9509V13.8809C12.9999 14.4909 12.6699 15.0709 12.1499 15.3809L11.3899 15.8409C11.2699 15.9209 11.1299 15.9509 10.9999 15.9509Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 22.7498H8.00023C3.38023 22.7498 2.52023 20.5998 2.30023 18.5098L1.55023 10.4998C1.44023 9.44977 1.41023 7.89977 2.45023 6.73977C3.35023 5.73977 4.84023 5.25977 7.00023 5.25977H17.0002C19.1702 5.25977 20.6602 5.74977 21.5502 6.73977C22.5902 7.89977 22.5602 9.44977 22.4502 10.5098L21.7002 18.4998C21.4802 20.5998 20.6202 22.7498 16.0002 22.7498ZM7.00023 6.74977C5.31023 6.74977 4.15023 7.07977 3.56023 7.73977C3.07023 8.27977 2.91023 9.10977 3.04023 10.3498L3.79023 18.3598C3.96023 19.9398 4.39023 21.2498 8.00023 21.2498H16.0002C19.6002 21.2498 20.0402 19.9398 20.2102 18.3498L20.9602 10.3598C21.0902 9.10977 20.9302 8.27977 20.4402 7.73977C19.8502 7.07977 18.6902 6.74977 17.0002 6.74977H7.00023Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.75C15.59 6.75 15.25 6.41 15.25 6V5.2C15.25 3.42 15.25 2.75 12.8 2.75H11.2C8.75 2.75 8.75 3.42 8.75 5.2V6C8.75 6.41 8.41 6.75 8 6.75C7.59 6.75 7.25 6.41 7.25 6V5.2C7.25 3.44 7.25 1.25 11.2 1.25H12.8C16.75 1.25 16.75 3.44 16.75 5.2V6C16.75 6.41 16.41 6.75 16 6.75Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0105 14.3898C15.6705 14.3898 15.3705 14.1598 15.2805 13.8198C15.1805 13.4198 15.4205 13.0098 15.8205 12.9098C17.7705 12.4198 19.5805 11.5698 21.2005 10.3898C21.5305 10.1498 22.0005 10.2198 22.2505 10.5598C22.4905 10.8898 22.4205 11.3598 22.0805 11.6098C20.3005 12.8998 18.3205 13.8298 16.1805 14.3698C16.1305 14.3798 16.0705 14.3898 16.0105 14.3898Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00072 14.4192C7.94072 14.4192 7.88072 14.4092 7.82072 14.3992C5.81072 13.9092 3.92072 13.0592 2.19072 11.8792C1.85072 11.6492 1.76072 11.1792 1.99072 10.8392C2.22072 10.4992 2.69072 10.4092 3.03072 10.6392C4.61072 11.7192 6.33072 12.4892 8.17072 12.9392C8.57072 13.0392 8.82072 13.4392 8.72072 13.8492C8.65072 14.1892 8.34072 14.4192 8.00072 14.4192Z",
    fill: "#FFB600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_8838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTypeIcon);
export default __webpack_public_path__ + "static/media/job-type-icon.c3805d7b03e3670c79fb4ce41d0f7ff2.svg";
export { ForwardRef as ReactComponent };